// IMPORT
const THREE = require('three')
import Runner from './runner'
// import Vehicle from './vehicle'
import {loadingManager, load, registerSize} from '../loader'
import {TimelineMax, TweenMax, Cubic, Expo, CustomEase} from 'gsap'
import lerp from 'lerp'
import {state as gameState} from '../main'
import {config as gameConfig} from '../config'
import raf from '../raf'

// ****************************************************************
//
// PARTS
//
// ****************************************************************
let base = require('src/../config').build.assetsPublicPath
const parts = [
  {
    model: {
      url: require('assets/models/runner/horse.json'),
      size: 159115
    },
    texture: {
      url: require('assets/models/bike/bike_chassis.png'),
      size: 55807
    },
    scale: 0.02
  }
]



// ****************************************************************
//
// CLASS
//
// ****************************************************************
class Horse extends Runner {

  constructor (config) {
    super(Object.assign(config, {parts: parts, sounds: null, type: 'horse'}))
    this.state.autoUpdateState = true
    this.model = new THREE.Object3D()
    this.mesh.add(this.model)
    // this.init()
    // this.model.rotation.y = THREE.Math.DEG2RAD * 180
    window.horse = this

    // raf.on('tick', this.update)
  }



  initModel () {
    let part = parts[0]
    let url = part.model.url
    let size = part.model.size
    registerSize(url, size)
    load(url, new THREE.JSONLoader(loadingManager), (results)=> {

      console.log('hi')
      // GEOMETRY
      part.geometry = results[0] // JSON
      part.geometry.computeFaceNormals()
      part.geometry.computeVertexNormals()

      // MATERIAL
      part.material = new THREE.MeshLambertMaterial({
        vertexColors: THREE.FaceColors,
        morphTargets: true
      })

      // MESH
      part.model = new THREE.Mesh(part.geometry, part.material)
      part.model.scale.setScalar(part.scale * gameConfig.worldScale)
      part.model.position.set(part.x || 0, part.y || 0, part.z || 0)
      this.model.add(part.model)

      // if (!this.state.isPlayer) {
      //   this.model.position.x = this.state.offset
      // }

      this.mixer = new THREE.AnimationMixer(part.model)
      let clip = THREE.AnimationClip.CreateFromMorphTargetSequence( 'gallop', part.geometry.morphTargets, 30 )
      this.mixer.clipAction( clip ).setDuration( 1 ).play()

    })
  }

  // **********************************************************************
  //
  // METHODS
  //
  // **********************************************************************
  // update = (delta)=> {
  //   console.log('horse update')
  //   if (this.mixer) {
  //     this.mixer.update(delta / 1000)
  //   }
  // }

  // update = (delta)=> {

  //   if (!gameState) return

  //   this.updatePosition()

  //   this.updateAnimation(delta)

  // }

  start () {

  }

  fadeInAnim = ()=> {}

}


export default Horse


// WEBPACK FOOTER //
// ./src/components/game/runner/horse.js